export const NotFoundPage = () => {
  return <div>página no encontrada</div>;
};
